export enum Relation {
  And = 'and',
  Or = 'or',
}

// 快捷按钮 勾选模式
export enum ShortcutActionType {
  // 组合，在现有勾选品类的基础上 增加快捷勾选按钮对应的品类
  Compose = 1,
  // 替换，替换掉现有勾选的品类，直接用快捷勾选按钮对应的品类作为最新的勾选品类
  Replace = 2,
}

// 快捷按钮 品类匹配模式
export enum ShortcutMatchType {
  // 全等匹配（默认）
  Exact = 'exact',
  // 包含匹配
  Includes = 'includes',
}
